export const zoomManagerMixin = {
  beforeMount() {
    this.currentZoomVal = this.getZoom;
    this.setZoom(this.currentZoomVal);
  },
  mounted() {
    this.setZoom(this.currentZoomVal);
  },
  data() {
    return {
      currentZoomVal: 100,
    };
  },
};
